export const identifyUserForAppcues = (user) => {
  if (window.Appcues !== undefined && window.Appcues !== null) {
    window.Appcues.identify(user.userId, {
      name: user.displayName,
      email: user.primaryEmailAddress,
      created_at: user.createDate
    });
  } else {
    loadAppcuesScript()
      .then(() => {
        identifyUserForAppcues(user);
      })
      .catch((error) => {
        // error
      });
  }
};

export const resetAppcues = () => {
  if (window.Appcues !== undefined && window.Appcues !== null) {
    window.Appcues.start();
  } else {
    loadAppcuesScript()
      .then(() => {
        resetAppcues();
      })
      .catch((error) => {
        // error
      });
  }
};

export const loadAppcuesScript = () => {
  return new Promise((resolve, reject) => {
    let script = document.createElement('script');
    script.src = '//fast.appcues.com/39107.js';
    script.addEventListener('load', () => resolve());
    script.addEventListener('error', (e) => reject(e));
    document.body.appendChild(script);
  });
};